import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { BenchmarkStore, BenchmarkState } from './benchmark.store';
import { BenchmarkService } from './benchmark.service';

@Injectable({ providedIn: 'root' })
export class BenchmarkQuery extends QueryEntity<BenchmarkState> {
    constructor(
        protected store: BenchmarkStore,
        private _benchmarkService: BenchmarkService
    ) {
        super(store);
        this._benchmarkService.getAvailable().subscribe();
    }

    selectAvailableBenchmarks$ = this.selectAll();
    selectBenchmark$ = (id: string) => this.selectEntity(id);
}
